import { TaxMode } from '../../../../../configuration';
import { configurationSettings } from '../../../../../configuration/configuration-settings';
import { getMonetaryValueWithZeroTax, multiplyMonetaryValue } from '../../../../../utils/monetary-value-utils';
/**
 * Calculate the amount of the tip which is defined by percentage.
 */
export const calculateTipAmountForPercentage = (monetaryValue, tipPercentage) => {
    const { taxMode } = configurationSettings.data.order;
    const percentageAmount = multiplyMonetaryValue(monetaryValue, tipPercentage / 100);
    const tipAmount = taxMode === TaxMode.Inclusive ? percentageAmount.valueIncludingTax : percentageAmount.valueExcludingTax;
    return getMonetaryValueWithZeroTax(tipAmount);
};
//# sourceMappingURL=calculate-tip-amount-for-percentage.js.map